import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import axios from "axios";
import ProjectRelatedBaseData from "./ProjectRelatedBaseData";

var PropertyCharacteristics =
/*#__PURE__*/
function (_ProjectRelatedBaseDa) {
  _inherits(PropertyCharacteristics, _ProjectRelatedBaseDa);

  function PropertyCharacteristics() {
    _classCallCheck(this, PropertyCharacteristics);

    return _possibleConstructorReturn(this, _getPrototypeOf(PropertyCharacteristics).call(this, "PropertyCharacteristics"));
  }

  return PropertyCharacteristics;
}(ProjectRelatedBaseData);

export default new PropertyCharacteristics();